









































import { CardTemplateProperty } from "@/graphql/client";
import { Component, Emit, Vue } from "vue-property-decorator";
import cardTemplateService from "@/service/cardTemplateService";
import ProgressLinear from "@/components/molecules/ProgressLinear.vue";

@Component({
  components: {
    ProgressLinear,
  },
})
export default class MessageCardTemplatePropertyDeleteDialog extends Vue {
  //---------------------------
  // data
  //---------------------------
  isOpen = false;
  isProgressing = false;
  item: CardTemplateProperty = cardTemplateService.defaultCardTemplateProperty;
  //---------------------------
  // mounted
  //---------------------------
  //---------------------------
  // computed
  //---------------------------
  //---------------------------
  // methods
  //---------------------------
  /**
   * ダイアログを表示します.
   */
  public open(item: CardTemplateProperty): void {
    this.item = item;

    this.isProgressing = false;
    this.isOpen = true;
  }

  /**
   * ダイアログを閉じます.
   */
  public close(): void {
    this.isProgressing = false;
    this.isOpen = false;
  }

  /**
   * 入力内容を保存します.
   */
  deleteItem(): void {
    this.isProgressing = true;
    //delete
    cardTemplateService
      .deleteCardTemplateProperty(this.item)
      .then((result) => {
        this.notifySuccess(result as CardTemplateProperty);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  /**
   * 処理成功
   */
  @Emit("onSuccess")
  public notifySuccess(deleted: CardTemplateProperty): CardTemplateProperty {
    return deleted;
  }
}
